import { Guid, Nillable } from '@web/utils';
import { WarehouseProductQuantityHistoryReasonType } from '../enums/warehouse-product-quantity-history-reason-type';
import { WarehouseProductQuantityHistoryReceipt } from './warehouse-product-quantity-history-receipt';
import { WarehouseProductQuantityHistoryRestock } from './warehouse-product-quantity-history-restock';
import { WarehouseProductQuantityHistoryRelease } from './warehouse-product-quantity-history-release';

export class WarehouseProductQuantityHistoryCollectionItem {
  public constructor(
    private readonly data: {
      id: Guid;
      change: number;
      quantityBeforeChange: number;
      quantityAfterChange: number;
      reason: WarehouseProductQuantityHistoryReasonType;
      receipt?: Nillable<WarehouseProductQuantityHistoryReceipt>;
      release?: Nillable<WarehouseProductQuantityHistoryRelease>;
      restock?: Nillable<WarehouseProductQuantityHistoryRestock>;
      createdAt: Date;
      createdBy?: Nillable<String>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get change(): number {
    return this.data.change;
  }

  public get absoluteChange(): number {
    return Math.abs(this.data.change);
  }

  public get quantityBeforeChange(): number {
    return this.data.quantityBeforeChange;
  }

  public get quantityAfterChange(): number {
    return this.data.quantityAfterChange;
  }

  public get reason(): WarehouseProductQuantityHistoryReasonType {
    return this.data.reason;
  }

  public get receipt(): Nillable<WarehouseProductQuantityHistoryReceipt> {
    return this.data.receipt;
  }

  public get release(): Nillable<WarehouseProductQuantityHistoryRelease> {
    return this.data.release;
  }

  public get restock(): Nillable<WarehouseProductQuantityHistoryRestock> {
    return this.data.restock;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get createdBy(): Nillable<String> {
    return this.data.createdBy;
  }
}
